angular.module('bmsApp.resource')
	.controller('ResourceDirectorySaveDialogCtrl', [
		'notify',
		'ResourceSvc',
		'$modalInstance',
		'directory',
		function (notify,
				  ResourceSvc,
				  $modalInstance,
				  directory) {

			var self = this;
			var form = {
				validator: {
					config: {},
					api: {}
				},
				processing: false
			};
			angular.extend(self, {
				directory: directory,
				form: form,
				methods: {
					cancel: cancel,
					submit: submit
				}
			});

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit(form) {
				if (form.$valid) {
					ResourceSvc.directory.save(self.directory)
						.then(function () {
							var message;
							if (self.directory.id) {
								message = 'Folder updated successfully.';
							}
							else {
								message = 'Folder created successfully.';
							}
							notify({
								message: message
							});
							$modalInstance.close();
						}, function (errors) {
							ResourceSvc.displayErrors(errors);
						});
				}
			}

		}
	]);
